import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { pushToArray, pushToObject } from 'src/app/services/convert.service';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { ILevel } from 'src/app/interfaces/resource';
import * as firebase from 'firebase/app';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { generateKeywords } from 'src/app/services/mapping.service';

@Injectable()
export class ResourceStore {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable lastVisible: any = null;
    @observable fetching: boolean = false;
    uploads: any[];

    @observable selectedLevel: any = null;
    allPercentage: Observable<any>;
    files: Observable<any>;
    constructor(
        private ds: DataService,
        private storage: AngularFireStorage,

    ) { }

    @action
    updateCoverDownloadURL(item: any, downloadURL: any, fileName, callback) {
        this.process = true;
        this.ds.booksRef().doc(item.key).update({
            fileurl: downloadURL,
            filename: fileName,
        }).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }


    @action
    async fetchListArray(collectionName, orderBy) {
        const docs = await this.ds.listRef(collectionName, orderBy).get().toPromise();
        return pushToArray(docs);
    }

    @action
    async fetchCollection(collectionName, orderBy) {
        const docs = await this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).get().toPromise();
        return pushToArray(docs);
    }

    @action
    async fetchActivityType(key) {
        const docs = await this.ds.firestoreRef().collection(COLLECTION_NAME.ACTIVITY_TYPE).doc(key).get().toPromise();
        return pushToObject(docs);
    }

    @action
    fetchDataList(collectionName, orderBy, callback) {
        this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).valueChanges().subscribe(docs => {
            callback(docs)
        })
    }


    @action
    fetchList(collectionName, orderBy, callback) {
        this.ds.listRef(collectionName, orderBy).valueChanges().subscribe(docs => {
            callback(docs)
        })
    }

    @observable fetchActivityByModuleRef: any;
    @action
    fetchActivityByModule(moduleKey, activityTypeKey, organizationKey, callback) {
        this.loading = true;
        this.fetchActivityByModuleRef = this.ds.activityByModuleRef(moduleKey, activityTypeKey, organizationKey)
            .valueChanges()
            .subscribe(docs => {
                this.loading = false;
                callback(docs)
            })
    }

    @action
    async fetchActivity(moduleKey, displayStatus, organizationKey: string) {
        this.lastVisible = null;
        this.loading = true;
        this.ds.activityRef(this.lastVisible, moduleKey, displayStatus, organizationKey).valueChanges().subscribe(docs => {
            this.data = docs
            this.empty = docs.length === 0;
            this.loading = false;
            if (docs.length > 0 && docs.length >= APPS.SIZE) {
                this.lastVisible = docs[docs.length - 1];
            } else {
                this.lastVisible = null;
            }
        })
    }

    @action
    async fetchSelectedLevel(levelKey) {
        this.loading = true;
        if (levelKey) {
            const doc = await this.ds.resourceLevelRef().doc(levelKey).get().toPromise();
            this.selectedLevel = pushToObject(doc);
        }
        else {
            this.selectedLevel = null;
        }
        return this.selectedLevel;
    }

    @action
    async fetchLessonImport() {
        const docs = await this.ds.lessonColRef().get().toPromise();
        const items = pushToArray(docs);
        const batch = this.ds.batch();
        items.map(m => {
            batch.update(this.ds.lessonColRef().doc(m.key).ref, {
                keyword: generateKeywords([`${m.name}`.trim()])
            })
        })
        batch.commit().then(() => {
        }).catch((error) => {
        })
    }

    @action
    async search(collectionName, displayStatus: any, organizationKey: string, search: string, lessonKey?: any, programKey?: any, trailAccount?: any, testingAccount?: any, levelKey?: any, callback?: any) {
        this.lastVisible = null;
        this.loading = true;
        this.fetchDataRef = this.ds.resourceRef(collectionName, this.lastVisible, displayStatus, organizationKey, lessonKey, programKey, trailAccount, testingAccount, levelKey, search)
            .valueChanges()
            .subscribe(docs => {
                this.data = docs
                this.empty = docs.length === 0;
                this.loading = false;
                if (docs.length > 0 && docs.length >= APPS.SIZE) {
                    this.lastVisible = docs[docs.length - 1];
                } else {
                    this.lastVisible = null;
                }
                callback && callback(this.data)
            })
    }


    @observable fetchDataRef: Subscription = null;
    @action
    async fetchData(collectionName, displayStatus: any, organizationKey: string, lessonKey?: any, programKey?: any, trailAccount?: any, testingAccount?: any, levelKey?: any, callback?: any) {
        this.lastVisible = null;
        this.loading = true;
        if(this.fetchDataRef) this.fetchDataRef.unsubscribe();
        this.fetchDataRef = this.ds.resourceRef(collectionName, this.lastVisible, displayStatus, organizationKey, lessonKey, programKey, trailAccount, testingAccount, levelKey)
            .valueChanges()
            .subscribe(docs => {
                this.data = docs.map((m:any,i)=>({...m,rowIndex:i+1}))
                this.empty = docs.length === 0;
                this.loading = false;
                if (docs.length > 0 && docs.length >= APPS.SIZE) {
                    this.lastVisible = docs[docs.length - 1];
                } else {
                    this.lastVisible = null;
                }
                
                callback && callback(this.data)
            })
    }

    @action
    async fetchMore(collectionName, displayStatus: any, organizationKey: string, levelKey?: any) {
        if (this.fetching || this.lastVisible === null || this.loading) { return; }
        this.fetching = true;
        const docsData = await this.ds.resourceRef(collectionName, this.lastVisible, displayStatus, organizationKey, null, null, null, null, levelKey).get().toPromise();
        const docs = pushToArray(docsData);
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
            this.lastVisible = docs[docs.length - 1];
        } else {
            this.lastVisible = null;
        }
        this.data = this.data.slice().concat(docs).map((m:any,i)=>({...m,rowIndex:i+1}));
        this.fetching = false;
    }

    @action
    async fetchSelectedData(collectionName, key: any, callback?) {
        const doc = await this.ds.firestoreRef().collection(collectionName).doc(key).get().toPromise();
        const data = pushToObject(doc);
        callback && callback(data)
        return data
    }

    @action
    addItem(collectionName, item: any, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        batch.set(ref, item, { merge: true });
        batch.update(statisticRef, { [`${collectionName}`]: firebase.firestore.FieldValue.increment(1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    deleteFile(collection, filename) {
        const ext = filename.split('.').pop()
        const name = filename.split('.').slice(0, -1).join('.')
        const fileRef = this.storage.ref(collection + '/' + filename);
        fileRef.delete()
        //   const fileArray = this.filesize.map(f => ({ name: name + '_' + f.size + '.' + ext }))
        //   for (const file of fileArray) {
        //     const resizeRef = this.storage.ref(collection + '/thumbs/' + file.name);
        //     resizeRef.delete()
        //   }
    }
    @action
    addItemWithFile(collectionName, item: ILevel, file, oldfilename, callback) {
        this.process = true;
        if (file && oldfilename) {
            this.deleteFile(collectionName, oldfilename)
        }

        if (file) {
            this.process = true;
            this.uploads = [];
            const allPercentage: Observable<number>[] = [];
            const filename = Math.random().toString(36).substring(7) + new Date().getTime() + file.name;
            const path = `${collectionName}/${filename}`;
            const ref = this.storage.ref(path);
            const task = this.storage.upload(path, file);
            const _percentage$ = task.percentageChanges();
            allPercentage.push(_percentage$);

            const uploadTrack = {
                fileName: filename,
                percentage: _percentage$
            }
            this.uploads.push(uploadTrack);
            const _t = task.then((f) => {
                return f.ref.getDownloadURL().then((url) => {
                    const data = {
                        ...item,
                        filename: filename,
                        fileurl: url
                    }
                    const batch = this.ds.batch();
                    const { organizationKey } = item;
                    const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
                    const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
                    batch.set(ref, data);
                    batch.update(statisticRef, { [`${collectionName}`]: firebase.firestore.FieldValue.increment(1) });
                    batch.commit().then(() => {
                        callback(true, null);
                    }).catch((error) => {
                        alert(error);
                        callback(false, error)
                    }).finally(() => {
                        this.process = false;
                    })
                })
            })
            this.allPercentage = combineLatest(allPercentage)
                .pipe(
                    map((percentages) => {
                        let result = 0;
                        for (const percentage of percentages) {
                            result = result + percentage;
                        }
                        return result / percentages.length;
                    }),
                );
        }
    }

    @action
    delete(collectionName, item: ILevel, callback) {
        this.loading = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        batch.delete(ref);
        batch.update(statisticRef, { [`${collectionName}`]: firebase.firestore.FieldValue.increment(-1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.loading = false;
        })
    }

    @action
    async deleteModule(item: any, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const moduleRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.MODULE).doc(item.key);
        const activityRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.ACTIVITY);
        const docs = await this.ds.activityByModuleDBRef(item.key).get().toPromise();
        const data = pushToArray(docs);
        data.forEach(m => {
            batch.delete(activityRef.doc(m.key))
        })
        batch.delete(moduleRef);
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
